/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { getLightElement, toggleAttribute } from '@tylertech/forge-core';
import { BADGE_CONSTANTS } from '../../badge';
import { BaseAdapter } from '../../core/base/base-adapter';
import { ICON_CONSTANTS } from '../../icon';
export class AppBarNotificationButtonAdapter extends BaseAdapter {
    constructor(component) {
        super(component);
    }
    setIcon(icon) {
        this._iconElement.name = icon;
    }
    initialize() {
        this._badgeElement = getLightElement(this._component, BADGE_CONSTANTS.elementName);
        this._iconElement = getLightElement(this._component, ICON_CONSTANTS.elementName);
    }
    setCount(value) {
        this._badgeElement.textContent = value != null ? String(value) : '';
    }
    setBadgeType(dot) {
        this._badgeElement.dot = dot;
    }
    setBadgeTheme(theme) {
        toggleAttribute(this._badgeElement, !!theme, BADGE_CONSTANTS.attributes.THEME, theme);
    }
    setBadgeVisible(isVisible) {
        this._badgeElement.open = isVisible;
    }
}
